import L from "leaflet";

// The background of the Leaflet maps (fleet maps, school map). By default
// the OpenFreeMap vector style — free, no key, commercial use allowed —
// drawn by MapLibre through its Leaflet binding, loaded only when a map is
// on the page (it is heavy). A raster tile URL (MAP_TILE_URL) still wins
// when the deployment sets one.
export const OPENFREEMAP_STYLE = "https://tiles.openfreemap.org/styles/liberty";
export const OPENFREEMAP_ATTRIBUTION =
  '<a href="https://openfreemap.org" target="_blank" rel="noopener">OpenFreeMap</a> ' +
  '<a href="https://www.openmaptiles.org/" target="_blank" rel="noopener">© OpenMapTiles</a> ' +
  'Data from <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>';

export async function addMapBackground(map, { styleUrl, tileUrl, attribution } = {}) {
  if (tileUrl) {
    return L.tileLayer(tileUrl, { attribution, maxZoom: 19 }).addTo(map);
  }

  const [{ maplibreGL }] = await Promise.all([
    import("@maplibre/maplibre-gl-leaflet"),
    import("maplibre-gl/dist/maplibre-gl.css"),
  ]);
  return maplibreGL({ style: styleUrl || OPENFREEMAP_STYLE, attribution: attribution || OPENFREEMAP_ATTRIBUTION })
    .addTo(map);
}
